export function sortImage (imageA, imageB) {
  return imageA.sort - imageB.sort
}
